export const meta: any = {
    HOME: {
        title: 'HOME.HOME_PAGE_TITLE',
        description: 'HOME.HOME_PAGE_DESCRIPTION',
        keywords: 'HOME.HOME_PAGE_KEYWORDS',
    },
    PRODUCTS: {
        title: 'PMKS_FINANCING_PAGE_TITLE',
        description: 'PMKS_FINANCING_PAGE_DESCRIPTION',
        keywords: 'PMKS_FINANCING_PAGE_KEYWORDS',
    },
    DIGITAL_GUARANTEE: {
        title: 'DIGITAL_GUARANTEE_PAGE_TITLE',
        description: 'DIGITAL_GUARANTEE_PAGE_DESCRIPTION',
        keywords: 'DIGITAL_GUARANTEE_PAGE_KEYWORDS',
    },
    FINANCING_CALCULATOR: {
        title: 'FINANCING_CALCULATOR.FC_PAGE_TITLE',
        description: 'FINANCING_CALCULATOR.FC_PAGE_DESCRIPTION',
        keywords: 'FINANCING_CALCULATOR.FC_PAGE_KEYWORDS',
    },
    DIGITAL_SERVICES: {
        title: 'DIGITAL_SERVICES.DIGITAL_SERVICES_PAGE_TITLE',
        description: 'DIGITAL_SERVICES.DIGITAL_SERVICES_PAGE_DESCRIPTION',
        keywords: 'DIGITAL_SERVICES.DIGITAL_SERVICES_PAGE_KEYWORDS',
    },
    INSURANCE: {
        title: 'INSURANCE_PAGE.INSURANCE_PAGE_TITLE',
        description: 'INSURANCE_PAGE.INSURANCE_PAGE_DESCRIPTION',
        keywords: 'INSURANCE_PAGE.INSURANCE_PAGE_KEYWORDS',
    },
    INSURANCE_LIBERTY: {
        title: 'INSURANCE_PAGE.LIBERTY_INSURANCE_PAGE_TITLE',
        description: 'INSURANCE_PAGE.LIBERTY_INSURANCE_PAGE_DESCRIPTION',
        keywords: 'INSURANCE_PAGE.LIBERTY_INSURANCE_PAGE_KEYWORDS',
    },
    ABOUT_US: {
        title: 'ABOUT_US.ABOUT_US_PAGE_TITLE',
        description: 'ABOUT_US.ABOUT_US_DESCRIPTION',
        keywords: 'ABOUT_US.ABOUT_US_KEYWORDS',
    },
    SME: {
        title: 'SME_PAGE.SME_PAGE_TITLE',
        description: 'SME_PAGE.SME_PAGE_DESCRIPTION',
        keywords: 'SME_PAGE.SME_PAGE_KEYWORDS',
    },
    PARTNERS: {
        title: 'PARTNERS.PARTNERS_PAGE_TITLE',
        description: 'PARTNERS.PARTNERS_DESCRIPTION',
        keywords: 'PARTNERS.PARTNERS_KEYWORDS',
    },
    ESG: {
        title: 'ESG_PAGE.ESG_PAGE_TITLE',
        description: 'ESG_PAGE.ESG_PAGE_DESCRIPTION',
        keywords: 'ESG_PAGE.ESG_PAGE_KEYWORDS',
    },
    FAQ: {
        title: 'FAQ.FAQ_PAGE_TITLE',
        description: 'FAQ.FAQ_PAGE_DESCRIPTION',
        keywords: 'FAQ.FAQ_PAGE_KEYWORDS',
    },
    PROMOTIONS: {
        title: 'CAMPAIGN_PARTNERSHIP_PAGE.CAMPAIGN_PARTNERSHIP_PAGE_TITLE',
        description:
            'CAMPAIGN_PARTNERSHIP_PAGE.CAMPAIGN_PARTNERSHIP_PAGE_DESCRIPTION',
        keywords:
            'CAMPAIGN_PARTNERSHIP_PAGE.CAMPAIGN_PARTNERSHIP_PAGE_KEYWORDS',
    },
    MY_KNP: {
        title: 'MYKNP_PAGE.MYKNP_PAGE_TITLE',
        description: 'MYKNP_PAGE.MYKNP_PAGE_DESCRIPTION',
        keywords: 'MYKNP_PAGE.MYKNP_PAGE_KEYWORDS',
    },
    GRANTS: {
        title: 'GRANTS.GRANTS_PAGE_TITLE',
        description: 'GRANTS.GRANTS_PAGE_DESCRIPTION',
        keywords: 'GRANTS.GRANTS_PAGE_KEYWORDS',
    },
    CGC_DEVELOPMENT_PROGRAMME: {
        title: 'CGC_DEV_PROG_PAGE.CGC_DEV_PROG_PAGE_TITLE',
        description: 'CGC_DEV_PROG_PAGE.CGC_DEV_PROG_PAGE_DESCRIPTION',
        keywords: 'CGC_DEV_PROG_PAGE.CGC_DEV_PROG_PAGE_KEYWORDS',
    },
    SIGN_UP: {
        title: 'REGISTER.REGISTER_PAGE_TITLE',
        description: 'REGISTER.REGISTER_PAGE_DESCRIPTION',
        keywords: 'REGISTER.REGISTER_PAGE_KEYWORDS',
    },
    LOGIN: {
        title: 'LOGIN.LOGIN_PAGE_TITLE',
        description: 'LOGIN.LOGIN_PAGE_DESCRIPTION',
        keywords: 'LOGIN.LOGIN_PAGE_KEYWORDS',
    },
    CONTACT_US: {
        title: 'SUPPORT.CONTACT_US_PAGE_TITLE',
        description: 'SUPPORT.CONTACT_US_PAGE_DESCRIPTION',
        keywords: 'SUPPORT.CONTACT_US_PAGE_KEYWORDS',
    },
    JC3: {
        title: 'JC3.SEO.TITLE',
        description: 'JC3.SEO.DESCRIPTION',
        keywords: 'JC3.SEO.KEYWORDS',
    },
    AWARDS: {
        title: 'AWARDS.PAGE_TITLE',
        description: 'AWARDS.PAGE_DESCRIPTION',
        keywords: 'AWARDS.PAGE_KEYWORDS',
    }
};
